module.exports = __webpack_public_path__ + "static/media/blacksheep.87a2166a.svg";